import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login'
import Index from '@/views/index'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      redirect: '',
      meta: { title: '首页' },
      children: [
        {
          path: 'order/',
          name: 'orderIndex',
          meta: { title: '订单', keepAlive: true },
          component: () => import('@/views/order/')
        },
        {
          path: 'order/detail/:orderNo',
          name: 'orderDetail',
          meta: { title: '订单详情' },
          component: () => import('@/views/order/detail')
        },
        {
          path: 'order/edit/:orderNo',
          name: 'orderEdit',
          meta: { title: '订单详情' },
          component: () => import('@/views/order/edit')
        },
        {
          path: 'order/listDeliver',
          name: 'orderListDeliver',
          meta: { title: '客服接收', keepAlive: true },
          component: () => import('@/views/order/listDeliver')
        },
        {
          path: 'order/deliverProcessDetail',
          name: 'DeliverProcessDetail',
          meta: { title: '投递处理' },
          component: () => import('@/views/order/deliverProcessDetail')
        },
        {
          path: 'order/listDoingDeliver',
          name: 'listDoingDeliver',
          meta: { title: '处理中投递' },
          component: () => import('@/views/order/listDoingDeliver')
        },
        {
          path: 'worktype',
          name: 'WorkType',
          meta: { title: '工种列表' },
          component: () => import('@/views/worktype')
        },
        {
          path: 'user',
          name: 'user',
          meta: { title: '用户列表' },
          component: () => import('@/views/user')
        },
        {
          path: 'user/info',
          name: 'userInfo',
          meta: { title: '修改密码' },
          component: () => import('@/views/user/info')
        },
        {
          path: 'user/resetPasswd',
          name: 'userResetPasswd',
          meta: { title: '修改密码' },
          component: () => import('@/views/user/resetPasswd')
        },
        {
          path: 'role',
          name: 'role',
          meta: { title: '角色列表' },
          component: () => import('@/views/role')
        },
        {
          path: 'role/bindMenu',
          name: 'bindMenu',
          meta: { title: '绑定菜单' },
          component: () => import('@/views/role/bindMenu')
        },
        {
          path: 'customer',
          name: 'customer',
          meta: { title: '客户列表' },
          component: () => import('@/views/customer')
        },
        {
          path: 'customer/contactsList',
          name: 'contactsList',
          meta: { title: '客户列表' },
          component: () => import('@/views/customer/contactsList')
        },
        {
          path: 'engineer',
          name: 'engineer',
          meta: { title: '工程师列表' },
          component: () => import('@/views/engineer')
        },
        {
          path: 'report/csCompletionRate',
          name: 'csCompletionRate',
          meta: { title: '客服完成率报表' },
          component: () => import('@/views/report/csCompletionRate')
        },
        {
          path: 'report/orderIncrease',
          name: 'OrderIncrease',
          meta: { title: '订单增长情况' },
          component: () => import('@/views/report/orderIncrease')
        },
        {
          path: 'report/personnelIncrease',
          name: 'PersonnelIncrease',
          meta: { title: '人员增长情况' },
          component: () => import('@/views/report/personnelIncrease')
        },
        {
          path: 'report/jobEngineerList',
          name: 'PersonnelIncrease',
          meta: { title: '在职工程师列表' },
          component: () => import('@/views/report/jobEngineerList')
        },
        {
          path: 'report/tobeEmployedEngineerList',
          name: 'TobeEmployedEngineerList',
          meta: { title: '在职工程师列表' },
          component: () => import('@/views/report/tobeEmployedEngineerList')
        },
        {
          path: 'report/inviteEngineerList',
          name: 'InviteEngineerList',
          meta: { title: '邀请奖励列表' },
          component: () => import('@/views/report/inviteEngineerList')
        },
        {
          path: 'message',
          name: 'Message',
          meta: { title: '消息列表' },
          component: () => import('@/views/message')
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    localStorage.removeItem('user')
  }
  if (!localStorage.getItem('menus')) {
    localStorage.removeItem('user')
  }
  let user = localStorage.getItem('user')
  if (!user && to.path !== '/login') {
    next('/login')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js